import { create } from 'zustand';
import { UserProfile, UpdateUserProfileRequest, UserNotificationPreferences } from '@/types/user';
import { userProfileService } from '@/lib/api/userProfileService';

interface UserProfileState {
  userProfile: UserProfile | null;
  isLoading: boolean;
  error: string | null;
  
  fetchUserProfile: () => Promise<UserProfile>;
  updateUserProfile: (data: UpdateUserProfileRequest) => Promise<UserProfile>;
  updateNotificationPreferences: (
    preferences: Partial<UserNotificationPreferences>
  ) => Promise<UserProfile>;
  reset: () => void;
}

export const useUserProfileStore = create<UserProfileState>((set, get) => ({
  userProfile: null,
  isLoading: false,
  error: null,
  
  fetchUserProfile: async () => {
    set({ isLoading: true, error: null });
    try {
      const profile = await userProfileService.getUserProfile();
      set({ userProfile: profile, isLoading: false });
      return profile;
    } catch (error) {
      set({ 
        error: error instanceof Error ? error.message : 'An unknown error occurred', 
        isLoading: false 
      });
      throw error;
    }
  },
  
  updateUserProfile: async (data: UpdateUserProfileRequest) => {
    set({ isLoading: true, error: null });
    try {
      const updatedProfile = await userProfileService.updateUserProfile(data);
      set({ userProfile: updatedProfile, isLoading: false });
      return updatedProfile;
    } catch (error) {
      set({ 
        error: error instanceof Error ? error.message : 'An unknown error occurred', 
        isLoading: false 
      });
      throw error;
    }
  },
  
  updateNotificationPreferences: async (preferences: Partial<UserNotificationPreferences>) => {
    return get().updateUserProfile({ notification_preferences: preferences });
  },
  
  reset: () => {
    set({ userProfile: null, isLoading: false, error: null });
  }
})); 